export default __webpack_public_path__ + "static/media/TwentyFourDemo.95b58025.mp4";